module.exports = __webpack_public_path__ + "img/ajax-loader.2cb43a4a.gif";